export const initialStateGpoDetails = {
  uuid: '',
  name: '',
  address: null,
  phone_number: null,
  website: ''
}
